<template>
  <div id="park">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <article-list :article-list-nav="pageData"></article-list>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import ArticleList from '@/components/ArticleList.vue'
  import banner from '../assets/images/banner/policiesBanner.png'

  export default {
    name: 'ArticleListPage',
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ArticleList
    },
    data() {
      return {}
    },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      }

    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 // $themeColor: #3e76fc;
  #park {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    .content {
      width: 1200px;
      display: flex;
      .content_left {
        width: 188px;
        background: url("../assets/images/article/listBg.png") no-repeat;
        .left_nav {
          width: 160px;
          height: 40px;
          padding-left: 48px;
          font-size: 16px;
          color: #333;
          line-height: 40px;
          background-color: #fff;
          margin-top: 10px;
          .nav_img {
            width: 7px;
            height: 11px;
            margin-left: 24px;
          }
        }
        .search_box {
          position: relative;
          .search {
            width: 160px;
            height: 40px;
            margin-top: 25px;
            border-radius: 25px;
            border: 1px solid #ccc;
            padding-left: 10px;
          }
          .search_img {
            width: 22px;
            height: 21px;
            position: absolute;
            right: 34px;
            top: 34px;
          }
        }

        .left_nav:first-of-type {
          margin-top: 25px;
        }
      }
      .content_right {
        width: 1112px;
        padding-left: 34px;
        .content_header {
          width: 100%;
          height: 86px;
          border-bottom: 1px solid $themeColor;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 28px;
            color: $themeColor;
          }
          .card {
            font-size: 14px;
            color: #333;
          }
        }
        .article_box {
          width: 100%;
          .article_list {
            height: 54px;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .article_title {
              color: #333;
              img {
                width: 10px;
                height: 12px;
                margin-right: 10px;
              }
            }
            .date {
              color: #666;
            }
          }
        }
        .page {
          margin: 70px 0 145px 0;
          display: flex;
          justify-content: center;
          .vue-pagination {
            font-size: 16px;
            color: #999;
            .vue-pagination li a {
              font-size: 16px !important;
            }
          }
        }
      }
    }
  }
</style>
